import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'indianCurrency',
  standalone: true,
})
export class IndianCurrencyPipe implements PipeTransform {
  transform(value: number, symbol: string = '₹'): string {
    if (value == null) {
      return '';
    }

    const formattedValue = Intl.NumberFormat('en-IN', {
      minimumFractionDigits: 2, // Ensures at least 2 decimals
      maximumFractionDigits: 2, // Limits to 2 decimals
    }).format(value);
    return `${symbol} ${formattedValue}`;
  }
}
